import {ReactComponent as TbDeviceWatch} from '../../assets/icons/TbDeviceWatch.svg'
import {ReactComponent as WatchIcon} from '../../assets/icons/WatchIcon.svg'
import {convertLabelListToObjectList} from '../form-utils/Constants'

import {component} from '../form/Constant'
import {
    genderList,
    patientOptionsList,
    titleList,
} from '../patient/PatientConstants'

export const timeZoneOptions = Intl.supportedValuesOf('timeZone')
export const languageOptions = [
    {
        value: 'english',
        label: 'English',
    },
    {
        value: 'bulgarian',
        label: 'Bulgarian',
    },
]
export const clientKeys = {
    clientAccount: 'clientAccount',
    appIcon: 'appIcon',
    appIconConfig: 'appIconConfig',
    username: 'username',
    email: 'email',
    title: 'title',
    firstName: 'firstName',
    lastName: 'lastName',
    gender: 'gender',

    basicInformation: 'basicInformation',
    name: 'name',
    description: 'description',

    hostname: 'hostname',

    configurationInformation: 'configuration',

    patientConfiguration: 'patientConfiguration',

    timeZone: 'timeZone',
    useDefaultPathway: 'useDefaultPathway',
    codeConfiguration: 'codeConfiguration',
    organizationName: 'organizationName',
    languageConfiguration: 'languageConfiguration',
    watchInteraction: 'watchInteraction',
    allowToAccessPatientPage: 'allowToAccessPatientPage',
    viewOptions: 'viewOptions',
}

export const clientList = [
    {
        key: clientKeys.clientAccount,
        description: ' Fill in the following information to create an account',
        note: 'The account will be sent to the client via email after completing the form',
        children: [
            {
                key: clientKeys.username,
                component: component.inputText,
                placeholder: 'Auto-generated if leaving blank',
                keyFilter: true,
                defaultValue: '',
            },
            {
                key: clientKeys.email,
                component: component.inputText,
                keyFilter: true,
                placeholder: 'Field is required',
                defaultValue: '',
            },
            {
                key: clientKeys.title,
                component: component.dropdown,
                options: titleList,
                defaultValue: titleList[0]?.value,
                placeholder: 'Input title',
            },
            {
                key: clientKeys.firstName,
                component: component.inputText,
                placeholder: 'Field is required',
            },
            {
                key: clientKeys.lastName,
                component: component.inputText,
                placeholder: 'Field is required',
            },
            {
                key: clientKeys.gender,
                component: component.dropdown,
                options: patientOptionsList.gender,
                defaultValue: genderList[0],
                placeholder: 'Input gender',
            },
        ],
    },
    {
        key: clientKeys.basicInformation,

        description:
            'Fill in the following basic information for easy management',
        note: 'This information is only shown to Super Admin - not System Users',
        children: [
            {
                key: clientKeys.organizationName,
                component: component.inputText,
                placeholder: 'Field is required',
                defaultValue: '',
            },
            {
                key: clientKeys.description,
                component: component.inputText,
                placeholder: 'Input description',
                defaultValue: '',
            },
        ],
    },
    {
        key: clientKeys.appIconConfig,
        note: 'The standard size of the image is 120px x 54px.',
        label: 'App Icon Config',
        description: `The required image ratio is 16:9.`,
        children: [
            {
                key: clientKeys.appIcon,
                label: 'App Icon',
                component: component.fileUpload,
                extraData: {
                    dimensionHeight: 16,
                    dimensionWidth: 9,
                },
            },
        ],
    },
    {
        key: clientKeys.configurationInformation,

        description:
            ' Fill in the following information to match this particular client',
        children: [
            {
                key: clientKeys.useDefaultPathway,
                component: component.checkbox,
                defaultValue: true,
                className: 'col-4',
            },
            {
                key: clientKeys.watchInteraction,
                component: component.checkbox,
                defaultValue: true,
                className: 'col-4',
            },
            {
                key: clientKeys.allowToAccessPatientPage,
                component: component.checkbox,
                defaultValue: true,
                className: 'col-4',
            },
            {
                key: clientKeys.hostname,
                component: component.inputText,
                placeholder: 'Input host name',
                defaultValue: 'https://subdomain.domain.com',
            },
            {
                key: clientKeys.timeZone,
                component: component.dropdown,
                options: timeZoneOptions
                    ? convertLabelListToObjectList(timeZoneOptions)
                    : [],
                placeholder: 'Select a timezone',
                defaultValue: timeZoneOptions ? timeZoneOptions[0] : '',
            },
            {
                key: clientKeys.languageConfiguration,
                component: component.multiSelect,
                options: languageOptions,
                placeholder: 'Select a main language',
            },
            {
                key: clientKeys.codeConfiguration,
                component: component.codeConfiguration,
                defaultValue: [],
                precondition: clientKeys.useCodeConfig,
            },
        ],
    },
]

export const clientHiddenColumns = [
    {key: 'numberOfHospitals'},
    {key: 'numberOfHCPs'},
    {key: 'numberOfPatients'},
    {key: 'username'},
    {key: 'title'},
    {key: 'firstName'},
    {key: 'lastName'},
    {key: 'avatar'},
    {key: 'gender'},
]

//#region Table
export const columnList = [
    {field: 'name', header: 'Name', initialShown: true},
    {field: 'description', header: 'Description', initialShown: true},
    {field: 'email', header: 'Email', initialShown: true},
    {field: 'timeZone', header: 'Time Zone', initialShown: true},
    {field: 'createdAt', header: 'Created At', initialShown: true},
]
//#endregion

//#region Information
export const clientInformationList = [
    {
        key: 'basicInformation',
        label: 'Basic Information',
        icon: 'pi pi-info-circle',
        description:
            'Contains the basic information of the client. This information is used to identify the client in the system.',
        children: [
            {
                key: clientKeys.name,
                label: 'Organization Name',
                component: component.inputText,
            },
            {
                key: clientKeys.description,
                label: 'Description',
                component: component.inputText,
            },
            {
                key: clientKeys.timeZone,
                label: 'Time Zone',
                component: component.dropdown,
                options: timeZoneOptions
                    ? convertLabelListToObjectList(timeZoneOptions)
                    : [],
                placeholder: 'Select a timezone',
                defaultValue: timeZoneOptions ? timeZoneOptions[0] : '',
            },
        ],
    },
    {
        key: 'accountInformation',
        label: 'Account Information',
        icon: 'pi pi-user',
        children: [
            {
                key: clientKeys.title,
                label: 'Title',
                options: patientOptionsList.title,
                component: component.dropdown,
            },
            {
                key: clientKeys.firstName,
                label: 'First Name',
                component: component.inputText,
            },
            {
                key: clientKeys.lastName,
                label: 'Last Name',
                component: component.inputText,
            },
            {
                key: clientKeys.username,
                label: 'Username',
                component: component.inputText,
            },
            {
                key: clientKeys.email,
                label: 'Email',
                component: component.inputText,
            },
            {
                key: clientKeys.gender,
                label: 'Gender',
                options: patientOptionsList.gender,
                component: component.dropdown,
            },
        ],
    },
]

export const clientConfigurationInfoList = [
    {
        key: clientKeys.configurationInformation,
        label: 'General Configuration',
        icon: 'pi pi-cog',
        description:
            'Contains the basic information of the client. This information is used to identify the client in the system.',
        children: [
            {
                key: clientKeys.codeConfiguration,
                label: 'Code Configuration',
                col: 'col-12',
                component: component.codeConfiguration,
            },
            {
                key: clientKeys.appIcon,
                label: 'App Icon',
                component: component.fileUpload,
                extraData: {
                    dimensionHeight: 16,
                    dimensionWidth: 9,
                },
            },
        ],
    },
]

export const clientPatientConfigurationList = [
    {
        key: clientKeys.patientConfiguration,
        label: 'Patient Default Configuration',
        icon: 'pi pi-user-edit',
        description:
            'Contains the basic information of the client. This information is used to identify the client in the system.',
        children: [
            {
                key: clientKeys.watchInteraction,
                label: 'Watch Interaction',
                component: component.toggleButton,
                icon: <TbDeviceWatch height={'26px'} width={'26px'} />,
                description:
                    'Enable interaction with the smartwatch to send health data to the system (This requires that the patient is assigned to the watch).',
                col: 'col-6',
                hideHeader: true,
                hideDescription: true,
            },
            {
                key: clientKeys.allowToAccessPatientPage,
                label: 'Allow to access Patient Page',
                icon: (
                    <i
                        className={`pi pi-sign-in `}
                        style={{fontSize: '20px'}}></i>
                ),
                description:
                    'Allow this patient access to the patient dashboard.',
                component: component.toggleButton,
                col: 'col-6',
                hideHeader: true,
                hideDescription: true,
            },
            {
                key: clientKeys.viewOptions,
                label: 'Watch Status View Options',
                component: component.radioButton,
                description:
                    'Select the watch view option for the patient detail page.',
                icon: (
                    <i className={`pi pi-eye`} style={{fontSize: '20px'}}></i>
                ),
                col: 'col-12',
                options: [
                    {
                        icon: <WatchIcon style={{width: 25, height: 25}} />,
                        value: 'normal',
                        label: 'Normal View',
                    },
                    {
                        icon: <i className="pi pi-list text-xl"></i>,
                        value: 'splitView',
                        label: 'Split View',
                    },
                    // {
                    //     icon: <WatchIcon style={{width: 25, height: 25}} />,
                    //     value: 'fullWatch',
                    //     label: 'Full Watch View',
                    // },
                    // {
                    //     icon: <WatchFace style={{width: 25, height: 25}} />,
                    //     value: 'watchFace',
                    //     label: 'Normal View',
                    // },
                ],
                defaultValue: 'splitView',
                hideHeader: true,
                hideDescription: true,
            },
        ],
    },
]
//#endregion
